import MessageForm from './MessageForm';

export default MessageForm;



// WEBPACK FOOTER //
// ./src/components/Pages/Messages/MessageForm/index.js